<script setup>
import { ref } from 'vue'

defineProps({
  url: {
    type: String,
    default: undefined
  }
})
const isDocumentLoad = ref(false)
const hasError = ref(false)

const handleDocumentLoad = () => {
  isDocumentLoad.value = true
}
const handleError = () => {
  hasError.value = true
}
</script>

<template>
  <div class="preview-container">
    <iframe
      v-if="url && !hasError"
      title="document preview"
      :src="url"
      :class="{ loading: !isDocumentLoad }"
      @load="handleDocumentLoad"
      @error="handleError"
    />
    <slot v-else />
  </div>
</template>

<style lang="scss" scoped>
.preview-container {
  overflow: hidden;
  iframe {
    pointer-events: none;
    margin: -4px -20px -24px -4px;
  }

  @-moz-document url-prefix() {
    iframe {
      margin: -35px -2px -24px -22px;
    }
  }

  a {
    display: inline-block;
  }
  .loading {
    background: url('~@/assets/heart.svg') center center no-repeat;
  }
}
</style>
